import React from 'react';
import PropTypes from 'prop-types';

import styles from './store-counts-by-location.scss';

function StoreCountsByLocation(props) {
  const { locations, onClick } = props;

  return (
    <ul className={styles['container']}>
      {Array.isArray(locations) &&
        locations.map((location, idx) => (
          <li className={styles['list-item']} key={idx}>
            <button
              className={styles['location']}
              name={location.name}
              onClick={() => onClick(location.name)}
            >
              {location.name.toLowerCase()} ({location.storeCount})
            </button>
          </li>
        ))}
    </ul>
  );
}

StoreCountsByLocation.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      storeCount: PropTypes.number.isRequired
    })
  ),
  onClick: PropTypes.func.isRequired
};

export default StoreCountsByLocation;
